export const PORTFOLIO_REFRESH_INTERVAL = 10000
export const PRO_PORTFOLIO_REFRESH_INTERVAL = 3000
export const EXCHANGE_REFRESH_INTERVAL = 600000
export const CURRENCY_REFRESH_INTERVAL = 600000
